import { render, staticRenderFns } from "./coinGameListModal.vue?vue&type=template&id=c831af9a&scoped=true"
import script from "./coinGameListModal.vue?vue&type=script&lang=js"
export * from "./coinGameListModal.vue?vue&type=script&lang=js"
import style0 from "./coinGameListModal.vue?vue&type=style&index=0&id=c831af9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c831af9a",
  null
  
)

export default component.exports